<template>
  <button class="btn" v-bind="$attrs" :disabled="disabled" v-on="$listeners">
    <!--@slot Use this slot to place content inside the button.-->
    <slot />
  </button>
</template>

<script>
export default {
  name: 'TkButton',
  props: {
    /**
     * Native button disabled attribute
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
